import './style.less';

ko.bindingHandlers.timePicker = {
  init: function init(element) {
    $(element).timePicker();
  }
};

// TODO: перенести настройки из main.js
